import { SETUP_STEP_LABELS } from '../../../pages/onboarding/rock-setup/copy.js'

/**
 * The guided Rock setup (`/setup/rock/:connectionId`, ROCK-ONBOARDING-REWORK
 * T4): its shell controls, plus one anchor per step seeded from the step
 * labels. The step bodies keep their existing `integrations.setup.*` and
 * `rock_setup.*` anchors, and Summary finishes the setup through its own
 * `integrations.onboarding.summary_*` buttons (so the shell has no Finish).
 * Administrators only, like the setup itself.
 */

const ROUTE = '/setup/rock/:id'
const ENTITY = 'rock_connection'
/** Rock connections have no object-level sharing: the admin role gate is the whole rule. */
const PERMISSION = 'view'

const STEP_INTENTS = {
  discover: 'See what Graphit found in your Rock: metrics, campuses and service times',
  match: 'Match Rock campuses and service times to Graphit',
  measurements: 'Choose which Rock measurements Graphit reads or creates',
  suggestions: 'Track metrics Graphit suggests from what your church does most weeks, or skip them',
  review: 'Check the starter dashboard Graphit suggests',
  summary: 'See what was set up and when the first numbers arrive, then finish',
}

const anchor = (id, label, intent, extra = {}) => ({ id, label, intent, route: ROUTE, minRole: 'admin', entity: ENTITY, permission: PERMISSION, ...extra })

const seededStepAnchors = Object.entries(SETUP_STEP_LABELS).map(([key, label]) => ({
  ...anchor(`rock_onboarding.step.${key}`, label, STEP_INTENTS[key] || label, { parent: 'rock_onboarding.step_indicator' }),
  seededFrom: 'onboardingSteps',
}))

export const ROCK_ONBOARDING_ANCHORS = [
  anchor('rock_onboarding.step_indicator', 'Setup progress', 'See which step of Rock setup you are on'),
  ...seededStepAnchors,
  anchor('rock_onboarding.save_and_exit', 'Save and exit', 'Leave Rock setup and come back to it later; progress is kept'),
  anchor('rock_onboarding.back', 'Back', 'Go back to the previous Rock setup step'),
  anchor('rock_onboarding.continue', 'Continue', 'Go on to the next Rock setup step'),
]
